<template>
  <div class="tax-invoice-request-display">
    <div class="card card-default mb-4">
      <h4 
        class="card-header" 
        v-html="title" />
      <div class="card-body">
        <p 
          class="text-danger" 
          v-if="!inspectionReport.complete">
          <i class="fa fa-exclamation-triangle" /> Report Incomplete
        </p>
        <p class="text-muted">
          {{ inspectionReport.StaffMember.fullName }} - <i class="far fa-clock fa-fw" /> {{ inspectionReport.createdAt | date_time_format }}
          <span class="float-right" v-if="$user.administrator"><i class="fas fa-stopwatch fa-fw" /> Time spent: {{ timeSpent }}</span>
        </p>
        <template v-if="inspectionReport.TaxInvoiceRequest">
          <p>
            <strong>
              Tax Invoice Request
            </strong>
            <br>
            <download-input
              :options="{ label: inspectionReport.TaxInvoiceRequest.referenceNumber, permalink: 'downloadFile'}"
              :value="{ objectKey: inspectionReport.TaxInvoiceRequest.InvoiceRequestPdf.objectKey }" />
          </p>
          <p v-if="inspectionReport.TaxInvoiceRequest.UploadedInvoice">
            <strong>
              Uploaded Invoice
            </strong>
            <br>
            <download-input
              :options="{ label: inspectionReport.TaxInvoiceRequest.UploadedInvoice.fileName, permalink: 'downloadFile'}"
              :value="{ objectKey: inspectionReport.TaxInvoiceRequest.UploadedInvoice.objectKey }" />
          </p>
        </template>
        <template v-if="inspectionReport.SentEmails.length">
          <sent-email
            v-for="email in inspectionReport.SentEmails"
            :key="email.uuid"
            :email="email">
          </sent-email>
        </template>
      </div>
      <div class="card-footer">
        <router-link
          :to="{ path: 'edit/' + inspectionReport.uuid, append: true }"
          class="my-1 btn btn-black">
          <i class="far fa-fw fa-edit" /> Edit
        </router-link>
        <router-link
          target="_blank"
          :to="{ path: '/api/public/pdf/' + inspectionReport.uuid + '?m=InspectionReport' }"
          class="my-1 btn btn-secondary"
          :class="{ 'disabled': !inspectionReport.ReportPdfUuid }">
          <i class="fa fa-fw fa-search" /> Preview
        </router-link>
        <download-input
          :disabled="!inspectionReport.ReportPdfUuid"
          :options="{ button: true, permalink: 'downloadFile'}"
          :value="{ objectKey: inspectionReport.ReportPdf ? inspectionReport.ReportPdf.objectKey : '' }" />
        <button 
          class="my-1 btn btn-primary" 
          @click="generatePdf()">
          <i class="fa fa-fw fa-redo-alt" /> Generate PDF
        </button>
        <button 
          class="my-1 btn btn-info"
          @click="upload()">
          <i class="fa fa-fw fa-upload" /> Upload
        </button>
        <button 
          class="my-1 btn btn-success" 
          @click="send()" 
          :disabled="!inspectionReport.complete">
          <i class="far fa-fw fa-paper-plane" /> Send
        </button>
        <button 
          class="my-1 btn btn-lime" 
          @click="duplicate()">
          <i class="far fa-fw fa-copy" /> Duplicate
        </button>
        <router-link 
          :to="'/tax-invoice-requests/new/' + inspectionReport.uuid + '?t=InspectionReport'"
          class="my-1 btn btn-warning"
          :class="{ 'disabled': !generateInvoiceButton }">
          <i class="fa fa-fw fa-dollar-sign" /> Invoice Request
        </router-link>
        <button 
          @click="deleteInspectionReport()" 
          class="my-1 btn btn-danger">
          <i class="fa fa-fw fa-trash" /> Delete
        </button>
      </div>
    </div>
  </div>
</template>
<script>
  import {
    DELETE_REPORT,
    DUPLICATE_INSPECTION_REPORT,
    GENERATE_INSPECTION_PDF,
    SEND_INSPECTION_REPORT,
    UPLOAD_INSPECTION_PDF
  } from '@/vuex/types'
  import SentEmail from '@/components/displays/SentEmail'
  import DownloadInput from '@/components/inputs/DownloadInput'
  export default {
    name: 'InspectionReportDisplay',
    props: {
      object: {
        type: Object,
        default () {
          return {}
        }
      }
    },
    components: {
      SentEmail,
      DownloadInput
    },
    computed: {
      timeSpent () {
        let minutes = this.inspectionReport.time / 60.0
        if (minutes > 120) {
          let hours = minutes / 60
          return hours.toFixed(2) + ' hours'
        } else {
          return minutes.toFixed(2) + ' min'
        }
      },
      fileName () {
        if (this.inspectionReport.ReportPdf) {
          return this.inspectionReport.ReportPdf.fileName.slice(0, -4)
        } else {
          return this.inspectionReport.propertyAddress
        }
      },
      generateInvoiceButton () {
        return this.inspectionReport.complete && !this.inspectionReport.TaxInvoiceRequestUuid
      },
      title () {
        if (this.inspectionReport.propertyAddress) {
          return '<i class="fa fa-fw fa-map-marker-alt"></i> ' + this.inspectionReport.propertyAddress
        } else {
          return '<i class="fa fa-fw fa-certificate"></i> New Report'
        }
      },
      inspectionReport () {
        return {
          StaffMember: {},
          ...this.object
        }
      }
    },
    methods: {
      async deleteInspectionReport () {
        await this.$store.dispatch(DELETE_REPORT, {
          reportUuid: this.inspectionReport.uuid,
          reportType: 'InspectionReport'
        })
      },
      async generatePdf () {
        await this.$store.dispatch(GENERATE_INSPECTION_PDF, this.inspectionReport)
      },
      async upload () {
        await this.$store.dispatch(UPLOAD_INSPECTION_PDF, this.inspectionReport.uuid)
      },
      async duplicate () {
        await this.$store.dispatch(DUPLICATE_INSPECTION_REPORT, this.inspectionReport.uuid)
      },
      async send () {
        await this.$store.dispatch(SEND_INSPECTION_REPORT, this.inspectionReport.uuid)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/cards/InspectionReport.vue